import styled from "styled-components";
import { Div } from "../../../common/ui/widgets";

export const SucessMessageWrapper = styled(Div)`
  padding: 10px 20px;
  background-color: white;
  color: black;
  width: auto;
  position: relative;
  padding: 16px;
  font-weight: 700;
  margin-top: 0 !important;
`;
